<script setup>
const route = useRoute()
</script>

<template>
  <div class="min-h-screen bg-page">
    <AppNavbar />
    <slot />
    <AppGiveawayPopup v-if="route.path === '/'" />
    <AppFooter />
    <div
      aria-hidden="true"
      class="grain-overlay pointer-events-none fixed inset-0 z-[9999]"
      style="
        background-image: url('/grain.svg');
        background-repeat: repeat;
        background-size: 200px 200px;
        opacity: 0.035;
        mix-blend-mode: multiply;
      "
    />
  </div>
</template>

<style scoped>
@media (max-width: 767px) {
  .grain-overlay { display: none; }
}
@media (prefers-reduced-motion: reduce) {
  .grain-overlay { display: none; }
}
</style>
